export default "__VITE_ASSET__CSnAkaB4__"